<script setup>
import { useCheckoutStepTracking } from "@/mixins/tracking/checkout-steps";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useScrollToTop } from "@/mixins/utils/scroll-to-top-on-init";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useMagasinStore } from "@/store/magasin";
import { usePanierStore } from "@/store/panier";
import { useContextStore } from "@/store/context";
import { useCheckoutStore } from "@/store/checkout";
import { useClientStore } from "@/store/client";

definePageMeta({
  middleware: "authenticated"
});

const redirection = ref(null);
const mountedFinished = ref(false);

const componentRef = ref();

const {
  id: magasinId,
  modesCommande,
  isEligibleAbonnementLad
} = storeToRefs(useMagasinStore());
const { status, hasAbonnement: hasAbonnementInPanier } = storeToRefs(
  usePanierStore()
);
const { layout } = storeToRefs(useContextStore());
const { checkout, getInfosPossibleService, typePanier } = storeToRefs(
  useCheckoutStore()
);
const { abonnements } = storeToRefs(useClientStore());

const { create: createCheckout, setStepValue } = useCheckoutStore();

const { scrollToTop } = useScrollToTop();
const { trackPage } = useTrackingPage();
const { trackCheckOutStep } = useCheckoutStepTracking();
scrollToTop();

onMounted(async () => {
  trackPage(trackingCodes.PAGETYPE.tunnel);
  trackCheckOutStep(trackingCodes.LABELGA.second, 2);
  setStepValue(1);
  if (!checkout.value) {
    await createCheckout();
    if (
      typePanier.value === "drive" &&
      isEligibleAbonnementLad.value &&
      (abonnementInCurrentMagasin.value || hasAbonnementInPanier.value)
    ) {
      const lad = modesCommande.value.find((mode) => mode.type === "LAD");
      let ladInfosService = getInfosPossibleService.value(lad.services[0].id);
      if (
        ladInfosService.possible &&
        ladInfosService.abonnement_applicable &&
        componentRef.value &&
        componentRef.value.preselection //uniquement en desktop, on vérifie la présence de la méthode
      ) {
        componentRef.value.preselection("LAD");
        return;
      }
    }
  }
  if (redirection.value) {
    await navigateToInternal(redirection.value, { replace: true });
  }
  mountedFinished.value = true;
});

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[`/components/pages/commander/${layout.value}.vue`]
  );
});
const abonnementInCurrentMagasin = computed(() => {
  return (
    abonnements.value.find(
      (abo) => abo.attributes.magasin_id === magasinId.value
    ) || null
  );
});

const setRedirect = (route) => {
  redirection.value = route;
};

watch(
  () => redirection.value,
  async (value) => {
    if (mountedFinished.value) {
      navigateToInternal(value, { replace: true });
    }
  }
);

watch(
  () => status.value,
  async (value) => {
    if (value.action === "SYNC_ARTICLES" && value.type === "PANIER_SUCCESS") {
      await createCheckout();
    }
  }
);
</script>

<template>
  <component
    :is="component"
    ref="componentRef"
    @setRedirect="setRedirect"
  />
</template>
